import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MoreVertIcon(props: IconProps) {
    return <Icon {...props} iconKey={"more_vert"}/>
}
